// removed by extract-text-webpack-plugin
module.exports = {"policy-modal-bottom-left":"policy-modal-bottom-left","ant-modal":"ant-modal","slideInFromBottom":"slideInFromBottom","ant-modal-mask":"ant-modal-mask","ant-modal-wrap":"ant-modal-wrap"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PolicyAgreementModal/PolicyAgreementModal.scss
// module id = 2701
// module chunks = 1